/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { connect } from 'react-redux';
import {
  IntlConfigSelectors,
  UserPreferencesSelectors,
  UserPreferencesActions,
} from '@spm/universal-access';
import LanguageDropdownComponent from './components/LanguageDropdownComponent';

/**
 * Retrieves data from the Redux store.
 *
 * @param state  the redux store state
 * @memberof PaymentsContainer
 */
const mapStateToProps = state => ({
  language: UserPreferencesSelectors.getUserSelectedLanguage(state),
  locales: IntlConfigSelectors.getLocales(state),
});

/**
 * Retrieve data from related rest APIs and updates the Redux store.
 *
 * @export
 * @param {function} dispatch the dispatch function
 * @returns {Object} the mappings.
 * @memberof LanguageDropdownContainer
 */
export const mapDispatchToProps = dispatch => ({
  onLanguageToggle: value => UserPreferencesActions.changeLanguage(dispatch, value),
});

/**
 * Renders the Language Dropdown feature on a page within the application.
 * @memberof LanguageDropdownContainer
 */
export default connect(mapStateToProps, mapDispatchToProps)(LanguageDropdownComponent);
